<template>
  <div
    v-if="$parent.user.group"
    class="wrapper"
    :class="[
      { 'nav-open': $sidebar.showSidebar },
      { rtl: $route.meta.rtlActive },
    ]"
  >
    <notifications></notifications>
    <side-bar
      :active-color="sidebarBackground"
      :background-image="sidebarBackgroundImage"
      :data-background-color="sidebarBackgroundColor"
    >
      <user-menu :title="userFullName" :avatar="getAvatar"></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          v-if="$parent.user.group.permissions.offers"
          v-bind:link="{ name: 'Kalkulacije', icon: 'article', path: '/files' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.offers"
          v-bind:link="{
            name: 'Radni nalozi',
            icon: 'fact_check',
            path: '/files?filter=confirmed',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.offers"
          v-bind:link="{
            name: 'Ponude',
            icon: 'sticky_note_2',
            path: '/offers',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.offers"
          v-bind:link="{
            name: 'Tabačna štampa',
            icon: 'border_color',
            path: '/job',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.clients"
          v-bind:link="{ name: 'Klijenti', icon: 'people', path: '/clients' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Magacin',
            icon: 'inventory_2',
            path: '/inventory',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Izlazne fakture',
            icon: 'arrow_forward',
            path: '/invoices',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Ulazne fakture',
            icon: 'arrow_back',
            path: '/expenses',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Plate',
            icon: 'euro_symbol',
            path: '/expenses?filter=salary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Računovodstvo',
            icon: 'account_balance',
            path: '/accounting',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Transakcije',
            icon: 'rule',
            path: '/transactions',
          }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.users"
          v-bind:link="{ name: 'Korisnici', icon: 'groups', path: '/users' }"
        >
        </sidebar-item>
        <sidebar-item
          v-if="$parent.user.group.permissions.expenses"
          v-bind:link="{
            name: 'Materijali',
            icon: 'hexagon',
            path: '/materials',
          }"
        >
        </sidebar-item>
        <sidebar-item :link="{ name: 'Alatke', icon: 'build' }">
          <sidebar-item
            :link="{ name: 'Blagajna ulaz', path: '/expenses?filter=cash' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Blagajna izlaz', path: '/invoices?filter=cash' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Blagajna stanja', path: '/accounting?filter=cash' }"
          ></sidebar-item>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar v-if="$root.window.width <= 992"></top-navbar>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
    </div>
  </div>
</template>
<script>
import TopNavbar from './TopNavbar.vue';
import MobileMenu from './Extra/MobileMenu.vue';
// import FixedPlugin from "../../FixedPlugin.vue";
import UserMenu from './Extra/UserMenu.vue';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    TopNavbar,
    MobileMenu,
    UserMenu,
    ZoomCenterTransition,
  },
  computed: {
    userFullName() {
      if (this.$parent.user) {
        return `${this.$parent.user.firstName} ${this.$parent.user.lastName}`;
      } else {
        return null;
      }
    },
    getAvatar() {
      if (this.$parent.user) {
        return `./img/faces/avatar_${this.$parent.user.avatarIndex}.jpg`;
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      sidebarBackgroundColor: 'black',
      sidebarBackground: 'green',
      sidebarBackgroundImage: './img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
